import styled from "@mui/material/styles/styled";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const LoginPageContainer = styled(Box)(() => ({
  display: "flex",
  width: "100%",
}));

export const LoginFormContainer = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "460px",
}));

export const LoginTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "48px",
  fontStyle: "normal",
  textAlign: "center",
  fontWeight: 600,
  lineHeight: "62px",
  marginTop: "150px",
  marginBottom: "16px",
}));

export const LoginSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Sora",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "32px",
  marginBottom: "44px",
  width: "460px",
}));

export const LoginLink = styled(RouterLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  textTransform: "capitalize",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));
